const CULTURE_LOCALE_STORAGE_KEY = 'cultureLocale';

const defaultSettings = {
  general: {
    companyName: '',
    timezone: 'UTC+3',
    dateFormat: 'DD/MM/YYYY',
    locale: localStorage.getItem(CULTURE_LOCALE_STORAGE_KEY) || 'en-US',
    numberFormat: {
      decimalPlaces: 2,
      maxDecimalPlaces: 4,
      currency: 'USD',
      currencyDecimals: 2,
      maxCurrencyDecimals: 4,
      useGrouping: true
    }
  },
  notifications: {
    email: true,
    browser: true,
    orders: true
  },
  appearance: {
    theme: localStorage.getItem('theme') || 'light'
  }
};

export default {
  namespaced: true,
  state: () => {
    const saved = JSON.parse(localStorage.getItem('userSettings') || '{}');
    return {
      ...defaultSettings,
      ...saved
    };
  },
  mutations: {
    SET_GENERAL(state, general) {
      state.general = general;
      // Persist locale separately for early boot usage
      if (state.general?.locale) {
        localStorage.setItem(CULTURE_LOCALE_STORAGE_KEY, state.general.locale);
      }
      localStorage.setItem('userSettings', JSON.stringify({ general: state.general }));
    }
  },
  actions: {
    updateGeneral({ commit }, general) {
      commit('SET_GENERAL', general);
    }
  },
  getters: {
    dateFormat: state => state.general.dateFormat,
    locale: state => state.general.locale,
    numberFormat: state => state.general.numberFormat,
    currency: state => state.general.numberFormat?.currency
  }
}; 